import httpUtil from '@/utils/axios'

export const MasterDataAPI = {
  getBrands: () => httpUtil.get('/master-data/brands'),
  getCooperativeChains: () => httpUtil.get('/master-data/cooperative-chains'),
  createCooperativeChain: (payload) => httpUtil.post('/master-data/cooperative-chains', payload),
  updateCooperativeChain: (id, payload) => httpUtil.put(`/master-data/cooperative-chains/${id}`, payload),
  deleteCooperativeChain: (id) => httpUtil.delete(`/master-data/cooperative-chains/${id}`),
  createBrand: (payload) => httpUtil.post('/master-data/brands', payload),
  updateBrand: (id, payload) => httpUtil.put(`/master-data/brands/${id}`, payload),
  deleteBrand: (id) => httpUtil.delete(`/master-data/brands/${id}`),
  getBrandProducts: (chainBrandId) => httpUtil.get('/master-data/brand-products', chainBrandId ? { chainBrandId } : {}),
  createBrandProduct: (payload) => httpUtil.post('/master-data/brand-products', payload),
  updateBrandProduct: (id, payload) => httpUtil.put(`/master-data/brand-products/${id}`, payload),
  deleteBrandProduct: (id) => httpUtil.delete(`/master-data/brand-products/${id}`),
  runLlmsSync: () => httpUtil.post('/master-data/llms-sync/run'),
  getDeviceArchives: () => httpUtil.get('/master-data/device-archives'),
  downloadDeviceTemplate: () => httpUtil.download('/master-data/device-archives/template', 'device_import_template.xlsx'),
  importDeviceArchives: (file, onProgress) => httpUtil.upload('/master-data/device-archives/import', file, onProgress),
  createDeviceArchive: (payload) => httpUtil.post('/master-data/device-archives', payload),
  updateDeviceArchive: (id, payload) => httpUtil.put(`/master-data/device-archives/${id}`, payload),
  deleteDeviceArchive: (id) => httpUtil.delete(`/master-data/device-archives/${id}`),
  getParts: () => httpUtil.get('/master-data/parts'),
  downloadPartTemplate: () => httpUtil.download('/master-data/parts/template', 'part_import_template.xlsx'),
  importParts: (file, onProgress) => httpUtil.upload('/master-data/parts/import', file, onProgress),
  createPart: (payload) => httpUtil.post('/master-data/parts', payload),
  updatePart: (id, payload) => httpUtil.put(`/master-data/parts/${id}`, payload),
  deletePart: (id) => httpUtil.delete(`/master-data/parts/${id}`)
}

export default MasterDataAPI
